const FragmentType = Object.freeze({
    Update: "U",
    Insert: "I"
});

export default FragmentType;
